<div class="px-6 pt-14 lg:px-8">
  <div class="mx-auto max-w-7xl py-32 sm:py-48 lg:py-56">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
      <!-- Left Column: Text Content -->
      <div class="lg:col-span-5" @fadeInUp>
        <div class="flex items-center space-x-4 mb-6">
          <div class="bg-indigo-100 text-indigo-600 rounded-full px-4 py-1 text-sm font-medium">{{ 'home.hero-section.new_feature' | translate }}</div>
          <div class="text-gray-600 text-sm font-medium flex items-center">
            {{ 'home.hero-section.qr_code_ordering' | translate }}
            <svg class="w-4 h-4" [ngClass]="{'ml-1': translate.currentLang === 'en', 'mr-1': translate.currentLang === 'ar', 'transform rotate-180': translate.currentLang === 'ar'}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>
        </div>
        <h1 class="text-[3.5rem] leading-[1.1] font-semibold tracking-tight text-gray-900" [innerHTML]="'home.hero-section.heading' | translate">
        </h1>
        <p class="mt-6 text-xl text-gray-600">
          {{ 'home.hero-section.description' | translate }}
        </p>
        <div class="mt-10 flex items-center gap-x-6">
          <a routerLink="/pricing" class="rounded-md bg-indigo-600 px-6 py-3 text-base font-semibold text-white hover:bg-indigo-500 transition-all duration-300 hover:scale-105 hover:shadow-lg">
            {{ 'home.hero-section.get_started' | translate }}
          </a>
          <a routerLink="/features" class="text-base font-semibold text-gray-900 flex items-center group">
            {{ 'home.hero-section.learn_more' | translate }}
            <span [ngClass]="{'ml-2': translate.currentLang === 'en', 'mr-2': translate.currentLang === 'ar', 'transform rotate-180': translate.currentLang === 'ar'}" class="transform transition-transform duration-300" [class.group-hover:translate-x-2]="translate.currentLang === 'en'" [class.group-hover:-translate-x-2]="translate.currentLang === 'ar'">→</span>
          </a>
        </div>
      </div>
      <!-- Right Column: Dashboard Image -->
      <div class="lg:col-span-7 mt-16 lg:mt-0" @fadeInRight>
        <div class="relative rounded-2xl bg-white shadow-2xl overflow-hidden">
          <!-- Navigation Bar -->
          <div class="bg-white border-b border-gray-200 p-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-4">
                <div class="text-lg font-semibold text-gray-900">{{ 'home.hero-section.dashboard.title' | translate }}</div>
              </div>
              <div class="flex items-center space-x-2">
                <div class="w-3 h-3 rounded-full bg-red-400"></div>
                <div class="w-3 h-3 rounded-full bg-yellow-400"></div>
                <div class="w-3 h-3 rounded-full bg-green-400"></div>
              </div>
            </div>
          </div>
          <!-- Dashboard Content -->
          <div class="p-6">
            <div class="flex items-center justify-between mb-6">
              <div class="flex items-center space-x-4 group">
                <svg class="w-8 h-8 text-indigo-600 transition-transform duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                </svg>
                <div class="text-lg font-semibold">{{ 'home.hero-section.dashboard.live_orders' | translate }}</div>
              </div>
              <div class="flex items-center space-x-2">
                <div class="relative">
                  <input type="text" placeholder="{{ 'home.hero-section.dashboard.search_placeholder' | translate }}" class="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm w-64 transition-all duration-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-indigo-300">
                  <svg class="w-5 h-5 text-gray-400 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <!-- Order List -->
            <div class="space-y-4">
              <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div class="flex items-center space-x-4">
                  <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                  <div class="text-sm font-medium">{{ 'home.hero-section.dashboard.order_1.title' | translate }}</div>
                </div>
                <div class="text-sm text-gray-500">{{ 'home.hero-section.dashboard.order_1.status' | translate }}</div>
              </div>
              <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div class="flex items-center space-x-4">
                  <div class="w-2 h-2 bg-yellow-500 rounded-full"></div>
                  <div class="text-sm font-medium">{{ 'home.hero-section.dashboard.order_2.title' | translate }}</div>
                </div>
                <div class="text-sm text-gray-500">{{ 'home.hero-section.dashboard.order_2.status' | translate }}</div>
              </div>
              <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div class="flex items-center space-x-4">
                  <div class="w-2 h-2 bg-indigo-500 rounded-full"></div>
                  <div class="text-sm font-medium">{{ 'home.hero-section.dashboard.order_3.title' | translate }}</div>
                </div>
                <div class="text-sm text-gray-500">{{ 'home.hero-section.dashboard.order_3.status' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
